module.exports = __webpack_public_path__ + "static/falling-cds-a451d1ff5a8f867639b1ec83b04c865e.mp4";